var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rentalObjectTenancies"},[_c('h2',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.defaultHeader))]),_c('RentalObjectTenancies',{attrs:{"rentalObjectId":_vm.rentalObjectId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }